import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _styled from "styled-components";
var _excluded = ["id", "isOpen", "className", "startingHeight", "endingHeight", "animateOpacity", "duration", "easing", "onAnimationStart", "onAnimationEnd", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import cx from 'classnames';
import AnimateHeight from 'react-animate-height';
import { prefix } from '../../tools/settings';
import { StyledCollapsible } from './Collapsible.styles';
import { jsx as _jsx } from "react/jsx-runtime";
var Collapsible = forwardRef(function (_ref, ref) {
  var _cx;

  var id = _ref.id,
      isOpen = _ref.isOpen,
      customClassName = _ref.className,
      _ref$startingHeight = _ref.startingHeight,
      startingHeight = _ref$startingHeight === void 0 ? 0 : _ref$startingHeight,
      _ref$endingHeight = _ref.endingHeight,
      endingHeight = _ref$endingHeight === void 0 ? 'auto' : _ref$endingHeight,
      _ref$animateOpacity = _ref.animateOpacity,
      animateOpacity = _ref$animateOpacity === void 0 ? true : _ref$animateOpacity,
      duration = _ref.duration,
      _ref$easing = _ref.easing,
      easing = _ref$easing === void 0 ? 'ease' : _ref$easing,
      onAnimationStart = _ref.onAnimationStart,
      onAnimationEnd = _ref.onAnimationEnd,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  var className = cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "-collapsible"), true), _defineProperty(_cx, customClassName, !!customClassName), _cx));
  return _jsx(_StyledAnimateHeight, {
    className: className,
    duration: duration,
    easing: easing,
    animateOpacity: animateOpacity,
    height: isOpen ? endingHeight : startingHeight,
    applyInlineTransitions: false,
    onAnimationStart: onAnimationStart,
    onAnimationEnd: onAnimationEnd,
    children: _jsx(StyledCollapsible, _objectSpread(_objectSpread({
      id: id,
      className: "".concat(prefix, "-collapsible__content"),
      ref: ref
    }, rest), {}, {
      children: children
    }))
  });
});
export default Collapsible;

var _StyledAnimateHeight = _styled(AnimateHeight).withConfig({
  displayName: "Collapsible___StyledAnimateHeight",
  componentId: "sc-wpptlo-0"
})({
  transition: 'height .2s ease,opacity .2s ease-in-out,transform .2s ease-in-out',
  '&.rah-animating--to-height-zero': {
    opacity: 0,
    transform: 'translateY(-0.625rem)'
  }
});